import { createRouter, createWebHistory } from 'vue-router'
//import HomeCommingSoon from '../views/HomeCommingSoon.vue'
import Home from '../views/home.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: Home,
    meta: { title: 'AWA - Atmospheric Water from the Amazon rainforest' }
  },
  {
    path: '/customer',
    name: 'customer',
    component: Home,
    meta: { title: 'AWA - Atmospheric Water from the Amazon rainforest' }
  },
  {
    path: '/pack',
    name: 'pack',
    component: Home,
    meta: { title: 'AWA - Atmospheric Water from the Amazon rainforest' }
  },
  {
    path: '/noono',
    name: 'noono',
    component: () => import(/* webpackChunkName: "about" */ '../views/noono.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404NotFound',
    component: Home,
    meta: { title: 'AWA - Atmospheric Water from the Amazon rainforest' }
  }
    
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router
